import { render, staticRenderFns } from "./PlatformSelect.vue?vue&type=template&id=53bf05d2&scoped=true&"
import script from "./PlatformSelect.vue?vue&type=script&lang=js&"
export * from "./PlatformSelect.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSelect.vue?vue&type=style&index=0&id=53bf05d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf05d2",
  null
  
)

export default component.exports